import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-levelcentersnap",
  "use": "icon-levelcentersnap-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-levelcentersnap\"><path d=\"M486.4 102.4l51.2 0 0 409.6-51.2 0 0-409.6Z\" p-id=\"4271\" /><path d=\"M486.4 819.2l51.2 0 0 102.4-51.2 0 0-102.4Z\" p-id=\"4272\" /><path d=\"M307.2 204.8l409.6 0 0 256-409.6 0 0-256Z\" p-id=\"4273\" /><path d=\"M768 563.2l0 204.8L256 768l0-204.8L768 563.2M819.2 512 204.8 512l0 307.2 614.4 0L819.2 512 819.2 512z\" p-id=\"4274\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol